import { render, staticRenderFns } from "./pending-task-list-item.vue?vue&type=template&id=906a4ab4"
import script from "./pending-task-list-item.vue?vue&type=script&lang=js"
export * from "./pending-task-list-item.vue?vue&type=script&lang=js"
import style0 from "./pending-task-list-item.vue?vue&type=style&index=0&id=906a4ab4&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports